<div class="datatable-r10">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div *ngIf="hasData && showtable; else nodatablock">
		<!-- data table -->
		<ngx-datatable
			class="{{ sectionclass }} ngx-datatable bootstrap material"
			[cssClasses]="cssClasses"
			[columnMode]="'flex'"
			[columns]="tableColumns"
			[offset]="0"
			[sortType]="'single'"
			[limit]="datatableconfig.limit ? datatableconfig.limit : 20"
			[rowHeight]="datatableconfig.rowHeight ? datatableconfig.rowHeight : 50"
			[headerHeight]="datatableconfig.headerHeight ? datatableconfig.headerHeight : 50"
			[footerHeight]="datatableconfig.footerHeight ? datatableconfig.footerHeight : 50"
			[selectionType]="'single'"
			[selectAllRowsOnPage]="false"
			[scrollbarV]="isVerticalScrollable"
			[sorts]="defaultSort"
			(select)="onSelect($event)"
			[selectCheck]="singleSelectCheck"
			[selected]="selectedRecord"
			[rows]="records"
			(sort)="onSort($event)"
		>
			<!--  custom cell -->
			<ng-template ngFor let-column [ngForOf]="tableColumns">
				<ngx-datatable-column
					name="{{ column.name }}"
					prop="{{ column.prop }}"
					[resizeable]="false"
					[sortable]="true"
					[cellClass]="column.cellClass"
					[headerClass]="column.headerClass"
					[flexGrow]="column.flexGrow"
				>
					<ng-template
						let-row="row"
						let-value="value"
						let-isSelected="isSelected"
						let-onCheckboxChangeFn="onCheckboxChangeFn"
						ngx-datatable-cell-template
					>
						<span *ngIf="column.checkboxable">
							<label
								class="datatable-checkbox"
								tooltip="{{ column.columnTooltip }}"
								placement="top"
								show-delay="500"
								tooltipPlacement="top"
							>
								<input type="checkbox" [checked]="isSelected" (change)="onCheckboxChangeFn($event)" />
							</label>
							<span title="{{ value }}">{{ value }}</span>
						</span>
						<span *ngIf="!column.checkboxable && column.pipe && column.pipe.transform">
							{{ column.pipe.transform(value) }}
						</span>
						<span
							class="network-logo"
							[ngStyle]="{ 'background-image': 'url(' + value + ')' }"
							*ngIf="isemail && !column.checkboxable && !column.pipe && column.name === 'logo_path' && isR13"
						></span>
						<span
							appTooltip
							[attr.title]="value"
							[options]="tooltipOptions"
							*ngIf="isemail && !column.checkboxable && !column.pipe && column.name !== 'logo_path' && isR13"
						>
							{{ value }}
						</span>
						<span
							appTooltip
							[attr.title]="value"
							[options]="tooltipOptions"
							*ngIf="isemail && !column.checkboxable && !column.pipe && !isR13"
						>
							{{ value }}
						</span>
						<span *ngIf="!isemail && !column.checkboxable && !column.pipe">
							{{ value }}
						</span>
					</ng-template>
				</ngx-datatable-column>
			</ng-template>
			<!-- end of cell template-->
		</ngx-datatable>
		<!-- end of datatable -->
	</div>

	<!-- when there is no data -->
	<ng-template #nodatablock>
		<div class="no-data-container">
			<h3 class="message">{{ nodatamessage && nodatamessage != 'undefined' ? nodatamessage : 'No Data Available' }}</h3>
		</div>
	</ng-template>
	<!-- END of no data div -->
</div>
